import { c as _c } from "react/compiler-runtime";
import { MyMenuFix, MyMenuFixOn } from '@module/svg/icons';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import { useContext } from 'react';
import { AllMenuContainer } from './AllMenuContainer';
import MenuContext from './MenuContext';
import { menuSvg } from './menuSvg';
export function CustomerMenu() {
  const $ = _c(13);
  const {
    navigateHandler,
    selectList,
    addItemHandler,
    isAdult,
    initMyListHandler
  } = useContext(MenuContext);
  let t0;
  if ($[0] !== addItemHandler || $[1] !== initMyListHandler || $[2] !== isAdult || $[3] !== navigateHandler || $[4] !== selectList) {
    let t1;
    if ($[6] !== addItemHandler || $[7] !== isAdult || $[8] !== navigateHandler || $[9] !== selectList) {
      t1 = (el, i) => {
        const active = selectList.some(s => s.title === el.title);
        return <div className="item" key={i}><DropdownMenuItem className="text-box" onClick={() => navigateHandler(el)}><div className="w-5 ">{menuSvg[el.img]}</div><div>{el.title}</div></DropdownMenuItem>{isAdult && <div className="favorites-icon" onClick={e => addItemHandler(e, el)}>{active ? <MyMenuFixOn /> : <MyMenuFix />}</div>}</div>;
      };
      $[6] = addItemHandler;
      $[7] = isAdult;
      $[8] = navigateHandler;
      $[9] = selectList;
      $[10] = t1;
    } else {
      t1 = $[10];
    }
    t0 = initMyListHandler("customer").map(t1);
    $[0] = addItemHandler;
    $[1] = initMyListHandler;
    $[2] = isAdult;
    $[3] = navigateHandler;
    $[4] = selectList;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[11] !== t0) {
    t1 = <AllMenuContainer title={"\uACE0\uAC1D\uC13C\uD130"} isbottom={true}><>{t0}</></AllMenuContainer>;
    $[11] = t0;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
}